<template>
  <sg-phone-change 
  class="pt-3" 
  :new-user="false" 
  form-message="Введите номер телефона"
  @done="onDone"
 />
</template>

<script>
import SgPhoneChange from '@/components/phone/SgPhone'

export default {
    components: {
        SgPhoneChange
    },
    methods: {
        /** добавить снэкбар */
        onDone() {
            this.$store.dispatch('settings/FETCH')
            .then( res => {
                this.$router.back()
                this.$eventBus.$emit('snackbar:open', {
                    message: 'Номер телефона изменен!'
                })
            })
        },
    }
}
</script>

<style>

</style>